import { appendCurrency, formatNumber } from './index.js';

// Pass in a number as either an int or string type
// Returns the string of the number in which 000 are seperated with commas
export const formatCurrency = (number, currency) =>
  (number || number === 0) && appendCurrency(formatNumber(number), currency);
